import { render, staticRenderFns } from "./OrderCannotModal.vue?vue&type=template&id=2da78682&scoped=true"
import script from "./OrderCannotModal.vue?vue&type=script&lang=js"
export * from "./OrderCannotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da78682",
  null
  
)

export default component.exports